const whoamiOptions = [
  { id: 1, title: 'Assureurs' },
  { id: 2, title: 'Courtier' },
  { id: 3, title: 'Loueur' },
  { id: 4, title: 'Gestionnaire de Flotte' },
  { id: 5, title: 'Entreprise' },
  { id: 6, title: 'Administration' },
] as const;

export default whoamiOptions;
